import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {
  Gallery,
  GalleryItem,
  ImageSize,
  ThumbnailsPosition,
} from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-gallery-page',
  templateUrl: './gallery-page.component.html',
  styleUrls: ['./gallery-page.component.css'],
})
export class GalleryPageComponent implements OnInit {
  @ViewChild('itemTemplate', { static: true }) itemTemplate: TemplateRef<any>;
  private listApi = environment.url + environment.galleryList;
  /**
   * Constructor for the GalleryPageComponent.
   * Injects the necessary dependencies: Gallery, Lightbox, ValueService, and ApiService.
   */
  constructor(
    /**
     * The gallery service to manage the gallery.
     */
    public gallery: Gallery,
    /**
     * The lightbox service to manage the lightbox.
     */
    public lightbox: Lightbox,
    /**
     * The ValueService to access the application state and data.
     */
    private getdata: ValueService,
    /**
     * The ApiService to make API calls to fetch the list of galleries.
     */
    private makeapi: ApiService
  ) {}
  /**
   * Initializes the component.
   * Calls the galleryList() function to fetch the list of galleries from the API.
   * Hides the loader and sets the visibility of the source to true.
   */
  ngOnInit(): void {
    // Hide the loader
    this.getdata.amizhthLoader('hide');
    // Set the visibility of the source to true
    this.getdata.isVisibleSource.next(true);
    // Fetch the list of galleries from the API
    this.galleryList();
  }
  list = {};
  galleryListData: any = [];
  noData = false;
  /**
   * Fetches the list of galleries from the API based on the pagination.
   * Updates the list object with the pagination parameters and calls the ListApi function
   * to refresh the list of galleries.
   */
  galleryList() {
    this.list = {
      /**
       * The number of items to fetch from the API
       */
      listSize: this.currentPageCount,
      /**
       * The page number to fetch from the API
       */
      pageNumber: this.paginationCount,
    };
    /**
     * Calls the ListApi function to fetch the list of galleries from the API
     */
    this.ListApi();
  }
  /**
   * Fetches the list of galleries from the API.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API.
   */
  ListApi() {
    // Show the loader
    this.getdata.amizhthLoader('show');

    // Call the API to fetch the list of galleries
    return this.makeapi
      .method(this.listApi, this.list, 'postunauth')
      .subscribe((data) => {
        // Hide the loader
        this.getdata.amizhthLoader('hide');

        // Check if the response contains any data
        if (data.responsemodelList != undefined) {
          // If there is data, update the component data
          this.noData = false;
          this.numberOfList = data.count;
          this.totalPages = data.totalPages;
          this.countList = data.responsemodelList.length;

          // Calculate the start and end count for the current page
          if (
            this.currentPage == this.totalPages &&
            this.countList != this.numberOfList
          ) {
            this.startCount = this.startCount + this.currentPageCount;
            this.EndCount = this.numberOfList;
          } else if (this.countList == this.numberOfList) {
            this.startCount = 1;
            this.EndCount = this.numberOfList;
          }

          // Update the list of galleries
          this.galleryListData = data.responsemodelList;

          // Set the image data
          this.imageData = this.galleryListData;

          // Load the gallery items
          this.viewPic();
        } else {
          // If there is no data, show the "No Data" message
          this.noData = true;
        }
      });
  }
  imageData;
  items: GalleryItem[];
  /**
   * Creates a lightbox gallery with the given image data
   * and sets the config. Also loads the gallery items.
   */
  viewPic() {
    // Create gallery items with image data
    const galleryItems = this.imageData.map((item) => ({
      type: 'imageViewer',
      data: {
        // Set the image source and thumb source
        src: item.galleryImageName,
        thumb: item.galleryImageName,
      },
    }));

    // Get a lightbox gallery ref
    const lightboxRef = this.gallery.ref('lightbox');
    // Set the config for the lightbox gallery
    lightboxRef.setConfig({
      // Set the image size to cover the container
      imageSize: ImageSize.Cover,
      // Set the thumb position to top
      thumbPosition: ThumbnailsPosition.Top,
      // Set the item template to the item template
      itemTemplate: this.itemTemplate,
      // Disable gestures
      gestures: false,
    });
    // Load the gallery items
    lightboxRef.load(galleryItems);
  }
  /**
   * Calculate the total number of pages based on the count of data.
   * This function is called whenever the data count changes.
   */
  Pagination_Count() {
    // Reset the loading state
    this.loading = false;
    // Get the total count of data
    const totalcount = this.numberOfList;
    // Set the total part count to the total count
    this.totalPartCount = totalcount;
    // Calculate the total number of pages by dividing the total count by the current page count
    // and rounding up to the nearest whole number.
    this.totalPages = Math.ceil(this.totalPartCount / this.currentPageCount);
  }
  p1 = 1;
  totalPartCount: any;
  paginationCount = 1;
  currentPageCount = 12;
  loading = false;
  numberOfList = 0;
  currentPage = 1;
  totalPages = 12;
  show_page = false;
  pagecount = 1;
  startCount = 1;
  EndCount = 12;
  countList = 0;
  /**
   * Handles pagination of the gallery.
   * @param page - The page to navigate to. Can be 'prev' or 'next'.
   */
  paginatePartList(page: string) {
    // Show the pagination controls
    this.show_page = true;

    // If the user is navigating to the previous page and is not on the first page
    if (page === 'prev' && this.currentPage > 1) {
      // Decrement the page count
      this.pagecount = this.pagecount - 1;

      // If the user is not on the first page
      if (this.currentPage > 1) {
        // Decrement the current page number
        let prevcount = this.currentPage;
        prevcount--;
        // Update the pagination count
        this.paginationCount = prevcount;
        // Update the current page number
        this.currentPage = prevcount;
      } else {
        // If the user is on the first page, set the pagination count to 1
        this.paginationCount = 1;
      }

      // Adjust the start and end counts for the new page
      if (this.EndCount !== this.numberOfList) {
        // Decrement the start count
        this.startCount = this.startCount - this.currentPageCount;
        // Decrement the end count
        this.EndCount = this.EndCount - this.currentPageCount;
      } else {
        // If we are at the last page, adjust the start and end counts to the last page
        this.startCount = this.startCount - this.currentPageCount;
        this.EndCount = this.EndCount - this.countList;
      }
    } else {
      // If the user is navigating to the next page
      // Increment the page count
      this.currentPage = this.currentPage + 1;
      this.pagecount = this.pagecount + 1;

      // If the user is not on the last page
      if (this.currentPage > 1) {
        // Increment the current page number
        let nextcount = this.currentPage - 1;
        nextcount++;
        // Update the pagination count
        this.paginationCount = nextcount;
      }

      // If the user is not on the last page
      if (this.currentPage !== this.totalPages) {
        // Increment the start and end counts for the new page
        this.startCount = this.startCount + this.currentPageCount;
        this.EndCount = this.EndCount + this.currentPageCount;
      }
    }

    // Call the gallery list function to update the list
    this.galleryList();
  }
}
